package com.essntl.core.unsplash.di

import com.essntl.core.unsplash.domain.UnsplashClient
import com.essntl.core.unsplash.data.UnsplashClientImpl
import org.koin.dsl.module

val unsplashModule
    get() =
        module {
            single<UnsplashClient> { UnsplashClientImpl(get()) }
        }
